import { FirestoreDataConverter, Timestamp } from 'firebase/firestore'

import { Candidate } from '../../../types'

export const candidateDataConverter: FirestoreDataConverter<Candidate> = {
  toFirestore: (model) => model,
  fromFirestore: (snapshot, options) => {
    const data = { id: snapshot.id, ...snapshot.data(options)! } as Candidate

    data.personalData.birthdate =
      data.personalData.birthdate instanceof Timestamp
        ? data.personalData.birthdate.toDate()
        : data.personalData.birthdate
    data.jobs?.jobs?.forEach((job) => {
      job.entryDate = job.entryDate instanceof Timestamp ? job.entryDate.toDate() : job.entryDate
      job.leaveDate = job.leaveDate instanceof Timestamp ? job.leaveDate.toDate() : job.leaveDate
    })

    return data
  },
}
